import { useCallback, useRef } from "react";
import { DynamicRowHeight } from "react-window";

/** Coalesce dynamic row height updates when many rows measure in one frame (avoids scroll jumps). */
export const useScheduleDynamicRowHeightUpdate = (
  dynamicRowHeight: DynamicRowHeight,
): ((index: number, size: number) => void) => {
  const pendingUpdatesRef = useRef<Map<number, number>>(new Map());
  const frameRef = useRef<number | undefined>(undefined);

  return useCallback(
    (index: number, size: number) => {
      pendingUpdatesRef.current.set(index, size);

      if (frameRef.current !== undefined) {
        return;
      }

      frameRef.current = requestAnimationFrame(() => {
        frameRef.current = undefined;
        const updates = pendingUpdatesRef.current;
        pendingUpdatesRef.current = new Map();

        updates.forEach((height, rowIndex) => {
          dynamicRowHeight.setRowHeight(rowIndex, height);
        });
      });
    },
    [dynamicRowHeight],
  );
};
